import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import { Map, Iterable } from 'immutable';

const middleWares = [thunkMiddleware];

if (process.env.NODE_ENV !== 'production') {

    const stateTransformer = state => {
        if (Iterable.isIterable(state)) return state.toJS();
        else return state;
    };

    const logger = createLogger({ stateTransformer });
    middleWares.push(logger);
}

const defaultInitialState = Map();

export default function configureStore(initialState = defaultInitialState) {
  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleWares)
  );
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js